import React, { Fragment } from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer';
const PlainHeader = ({title}) => {
    const styles = StyleSheet.create({
        titleContainer: {
            width: '100%',
            marginBottom: 5,
            marginTop: 20,
        },
        title: {
            fontSize: '13px',
            fontStyle: 'bold',
            flexGrow: 1,
            color: '#4B5660',
            textTransform: 'capitalize',

    }
    });
return (
    <Fragment>
        <View style={styles.titleContainer}>
            <Text style={styles.title}>{title}</Text>
        </View>
    </Fragment>
)
}

export default PlainHeader